import React, { type ReactElement, useEffect } from 'react'
import { useRouter } from 'next/router'
import Head from 'next/head'
import Link from 'next/link'
import Breadcrumbs from '../../../../shared/components/ui/breadcrumbs/Breadcrumbs'
import { PageHeading } from '../../../../shared/components/ui/headings/PageHeading'
import { determineBrowserTabName } from '../../../../shared/themes/logoFunctions'
import { APP_DATA_EXPORTS_PATH } from '../../../../pages/app/data-exports'
import { executeUserDataExportsRetrieve } from '../index/executeUserDataExportsRetrieve'
import { DataExportsDetail } from './DataExportsDetail'

export function Container (): ReactElement {
  const router = useRouter()
  const { id } = router.query

  useEffect(() => {
    if (!id) { return }
    void executeUserDataExportsRetrieve(id as string)
  }, [id])

  return (
    <>
      <Head>
        <title>{`Data Export ${id as string} - ${determineBrowserTabName()}`}</title>
      </Head>

      <Breadcrumbs breadcrumbs={[{ path: APP_DATA_EXPORTS_PATH, text: 'Data Exports' }, { text: (id as string) }]} />
      <PageHeading text="Quickly and easily view and manage your latest data exports." />
      <div className="my-6">
        <Link href={APP_DATA_EXPORTS_PATH}>
          <div className="underline">
            {'< '}
            Back to Data Exports
          </div>
        </Link>
      </div>
      <DataExportsDetail />
    </>
  )
}
